import script from "./LiveCourt.vue?vue&type=script&setup=true&lang=js"
export * from "./LiveCourt.vue?vue&type=script&setup=true&lang=js"

import "./LiveCourt.vue?vue&type=style&index=0&id=26ca282e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26ca282e"]])

export default __exports__